import { getInstance } from "./authWrapper";
import { LOGIN_ROUTE, validatePoSession } from "./poSession";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    try {
      const session = await validatePoSession();
      if (session && session.authenticated === true) {
        return next();
      }
    } catch (error) {
      // A missing, expired, cross-site, or revoked PO token is not a session.
    }

    if (authService && !authService.loading && !authService.isAuthenticated) {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      return next(false);
    }
    return next(LOGIN_ROUTE);
  };

  if (!authService) {
    return next(LOGIN_ROUTE);
  }
  if (!authService.loading) {
    return fn();
  }

  const unwatch = authService.$watch("loading", loading => {
    if (loading === false) {
      unwatch();
      return fn();
    }
  });
};
